module.exports = __webpack_public_path__ + "static/media/Techstars.27cb73ae.svg";